import { gql } from '@generated/gql';

export const submitOrder = gql(`
mutation SubmitOrder($input: SubmitOrderInput!) {
  submitOrder(input: $input) {
    orderId
  }
}
`);
